/**
 * @name isValidEmail
 * @description lightweight helper that tests provided email
 * string for validity and returns boolean result
 * @param email {string}
 * @returns boolean
 */

export const isValidEmail = (email?: string) =>
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email || '',
    );
